<template>
  <div>
    <b-notification :closable="false">
      <strong>{{
        $t(
          'compCarbonFormsRactivitiesComponentsFertilisersHelpCalculatingMethod.title-1'
        )
      }}</strong>
      <br />
      <strong
        ><em>{{
          $t(
            'compCarbonFormsRactivitiesComponentsFertilisersHelpCalculatingMethod.title-1-1'
          )
        }}</em></strong
      >
      <br />
      <span
        v-html="
          $t(
            'compCarbonFormsRactivitiesComponentsFertilisersHelpCalculatingMethod.info-1-1'
          )
        "
      />
      <br />
      <br />
      <strong
        ><em>{{
          $t(
            'compCarbonFormsRactivitiesComponentsFertilisersHelpCalculatingMethod.title-1-2'
          )
        }}</em></strong
      >
      <br />
      <span
        v-html="
          $t(
            'compCarbonFormsRactivitiesComponentsFertilisersHelpCalculatingMethod.info-1-2'
          )
        "
      />
    </b-notification>
  </div>
</template>

<script>
export default {
  name: 'HelpCalculatingMethod'
}
</script>
